import React, { useState } from 'react'
import PageHead from '../components/PageHead'
import Container from '../ui/comp/Container'
import Input from '../ui/forms/Input'
import Select from '../ui/comp/Select'
import Checkbox from '../ui/forms/Checkbox'
import Button from '../ui/comp/Button'
import { useMutation } from '@tanstack/react-query'
import { Axios } from '../utils/Axios'
import { v4 } from 'uuid'
import { IoTrash } from 'react-icons/io5'
import { useCategory } from '../hooks/useCategory'
import { useNavigate } from 'react-router-dom'
import Avatar from '../ui/comp/Avatar'
import ImageContainer from '../ui/comp/ImageContainer'
import { displayImage } from '../utils/config'
import FroalaEditor from 'react-froala-wysiwyg'



function CreateProduct() {
    const navigate = useNavigate();

    const [tab, setTab] = useState(1)

    const [formData, setFormData] = useState({
        name: "",
        description: "",
        base_price: "",
        stock: "",
        discount: "",
        customable: false,
        customise_price: 0.00,
        sub_category: '',
        in_stock: true,
        category: "",
        dealPrice: "",
        dealStart: "",
        dealEnd: "",
        isBundleProduct: false
    })

    const [isPromo, setIsPromo] = useState(false)

    const [variants, setVariants] = useState([])
    const [images, setImages] = useState([]);

    // ==============================================================================================

    const [colors, setColors] = useState("")
    const [sizes, setSizes] = useState("")
    const [material, setMaterial] = useState("")
    const [type, setType] = useState("")


    const generateVariants = () => {
        const color = colors.split('|')
        const size = sizes.split('|')
        const materials = material.split('|')
        const types = type.split('|')

        const newVariants = [];

        color.forEach(color => {
            size.forEach(size => {
                materials.forEach(material => {
                    types.forEach(type => {
                        newVariants.push({
                            id: v4(), color, size, material, type,
                            image: "", stock: 0, price: formData.base_price,
                        })
                    })
                })
            })
        })

        setVariants([...newVariants])
    }

    const handleImage = (index, e) => {
        const updatedList = [...variants];
        updatedList[index].image = e.target.value;
        setVariants([...updatedList])
    }


    const handlePrice = (index, e) => {
        const updatedList = [...variants];
        updatedList[index].price = e.target.value;
        setVariants([...updatedList])
    }

    const handleStock = (index, e) => {
        const updatedList = [...variants];
        updatedList[index].stock = e.target.value;
        setVariants([...updatedList])
    }

    // ============================================================================================


    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setFormData({ ...formData, [id]: value })
    }



    // Adding Product

    const { mutate, isPending, error, isSuccess } = useMutation({
        mutationFn: async (formData) => {
            return Axios.post('/product/add', formData)
        }
    })

    const addProduct = (e) => {

        e.preventDefault()

        if (!images.length) {
            window.alert("Product images reaguired")
            return;
        }

        const formDatas = new FormData();

        Object.keys(formData).forEach((key) => {
            formDatas.append(key, formData[key])
        })

        formDatas.append('images', JSON.stringify(images))
        formDatas.append("variants", JSON.stringify(variants))
        formDatas.append("isPromo", isPromo)

        mutate(formDatas)
    }

    if (isSuccess) {
        navigate('/products')
    }

    if (error) {
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }


    // Get Seletected Images
    const getSelectedImages = (files) => {
        setImages(files)
    }

    const { data: categories } = useCategory()


    return (
        <div className='w-full relative'>
            <PageHead title="Create Product" />

            {/* Navigations */}

            <div className="flex mt-7 items-center gap-4">
                <button
                    onClick={() => setTab(1)}
                    className={` ${tab === 1 ? 'text-primary font-medium' : "text-gray-600"}`}
                >General
                </button>
                <button
                    onClick={() => setTab(2)}
                    className={` ${tab === 2 ? 'text-primary font-medium' : "text-gray-600"}`}
                >
                    Variants
                </button>
            </div>


            {/* Product Form */}
            {tab === 1 && (
                <div className="w-full mt-8">
                    <Container border={true}>
                        {error && (
                            <div className='text-red-500 my-5 text-sm capitalize'>{error?.response?.data || error.message}</div>
                        )}
                        {/* Form */}
                        <div className="flex gap-7 py-5 flex-col xl:flex-row w-full">

                            {/* Form 1 ==========================================  */}
                            <div className="w-full space-y-7 xl:w-7/12">

                                {/* Product Name */}

                                <div className='space-y-2'>
                                    <h4 className="font-medium text-sm">Product Name</h4>
                                    <Input
                                        id="name"
                                        value={formData.name}
                                        placeholder="Type name here"
                                        onChange={handleInputChange}
                                    />
                                </div>

                                {/* Description */}

                                <div className='space-y-2'>
                                    <h4 className="font-medium text-sm">Product Description</h4>
                                    <FroalaEditor
                                        tag="textarea"
                                        model={formData?.description}
                                        onModelChange={(data) => setFormData({ ...formData, description: data })}
                                    />
                                </div>

                                {/* Category and stock */}


                                <div className="flex gap-4">

                                    <div className='space-y-2 w-full'>
                                        <h4 className="font-medium text-sm">Category</h4>
                                        <Select classic={true}
                                            onChange={(e) => {
                                                setFormData({ ...formData, category: e.target.value })
                                            }}
                                        >
                                            <option value="">Select Category here</option>
                                            {categories && categories?.map((category, i) => (
                                                <option key={i} value={JSON.stringify(category)}>{`${category?.name}`}</option>
                                            ))}
                                        </Select>

                                        {formData?.category && (
                                            <div>
                                                <Select classic={true} onChange={(e) => setFormData({ ...formData, sub_category: e.target.value })}>
                                                    <option value="">Select Category here</option>
                                                    {JSON.parse(formData.category)?.Subcategory?.map((cat, i) => (
                                                        <option key={i} value={`${cat?.id}`}>{`${cat?.name}`}</option>
                                                    ))}
                                                </Select>
                                            </div>
                                        )}
                                    </div>

                                    <div className='space-y-2 w-full'>
                                        <h4 className="font-medium text-sm">Product Stock</h4>
                                        <Input
                                            id='stock'
                                            value={formData.stock}
                                            onChange={handleInputChange}
                                            placeholder="Stock"
                                        />
                                    </div>

                                </div>




                                {/* Price and Discount*/}

                                <div className="flex gap-4">
                                    <div className='space-y-2 w-full'>
                                        <h4 className="font-medium text-sm">Product Price</h4>
                                        <Input
                                            id="base_price"
                                            value={formData.base_price}
                                            onChange={handleInputChange}
                                            placeholder="Price"
                                        />
                                    </div>

                                    {/* Discount */}

                                    <div className='space-y-2 w-full'>
                                        <h4 className="font-medium text-sm">Discount</h4>
                                        <Input
                                            id="discount"
                                            value={formData.discount}
                                            onChange={handleInputChange}
                                            placeholder="Dicount %"
                                        />
                                    </div>
                                </div>

                                {/* Customise and Publish and isBundleProduct */}
                                <div className="flex gap-4">
                                    <Checkbox
                                        value={formData.customable}
                                        label={"Customised"}
                                        onChange={(e) => setFormData({ ...formData, customable: e.target.checked })}
                                        checked={formData.customable}
                                    />
                                    <Checkbox
                                        value={formData.in_stock}
                                        label={"In Stock"}
                                        checked={formData.in_stock}
                                        onChange={(e) => setFormData({ ...formData, in_stock: e.target.checked })}
                                    />
                                    <Checkbox
                                        value={formData.isBundleProduct}
                                        label={"Bundle product"}
                                        checked={formData.isBundleProduct}
                                        onChange={(e) => setFormData({ ...formData, isBundleProduct: e.target.checked })}
                                    />
                                </div>

                                {/* Customise price */}
                                {formData?.customable && (
                                    <div className='space-y-2 w-full'>
                                        <h4 className="font-medium text-sm">Customisation Price</h4>
                                        <Input
                                            id="customise_price"
                                            value={formData.customise_price}
                                            onChange={handleInputChange}
                                            placeholder="Customisation Price"
                                        />
                                    </div>
                                )}

                            </div>



                            {/* Form 2 ===================================================  */}
                            <div className="w-full xl:w-5/12 space-y-7">



                                {/* Promotions and Deals */}
                                <div className='space-y-3 w-full'>
                                    <Checkbox
                                        value={isPromo}
                                        label={"Promotion and Deal"}
                                        checked={isPromo}
                                        onChange={(e) => setIsPromo(!isPromo)}
                                    />

                                    {isPromo && (
                                        <div className="space-y-3">
                                            <div className='space-y-2 w-full'>
                                                <h4 className="font-medium text-sm">Deal Price</h4>
                                                <Input
                                                    id="dealPrice"
                                                    value={formData.dealPrice}
                                                    onChange={handleInputChange}
                                                    type='number'
                                                />
                                            </div>

                                            <div className='space-y-2 w-full'>
                                                <h4 className="font-medium text-sm">Deal Start</h4>
                                                <Input
                                                    id="dealStart"
                                                    value={formData.dealStart}
                                                    onChange={handleInputChange}
                                                    placeholder="Deal Start"
                                                    type='datetime-local'
                                                />
                                            </div>

                                            <div className='space-y-2 w-full'>
                                                <h4 className="font-medium text-sm">Deal End</h4>
                                                <Input
                                                    id="dealEnd"
                                                    value={formData.dealEnd}
                                                    onChange={handleInputChange}
                                                    placeholder="Deal End"
                                                    type='datetime-local'
                                                />
                                            </div>
                                        </div>
                                    )}

                                </div>


                                {/* Product Gallery  */}
                                <div className='space-y-2 w-full'>
                                    <h4 className="font-medium text-sm">Product Gallery</h4>
                                    {/* View Images */}
                                    {images.length ? (
                                        <div className="flex flex-wrap gap-4">
                                            {images.map((image, i) => (
                                                <div key={i} className='relative max-w-28 p-1 border rounded-lg'>
                                                    <button onClick={() => setImages(images.filter(img => img !== image))} className='absolute p-2 bg-white rounded-lg text-red-600'><IoTrash /></button>
                                                    <img src={displayImage(image)} alt="" className='w-full object-cover' />
                                                </div>
                                            ))}
                                        </div>
                                    ) : null}

                                    <div className="mt-4">
                                        <ImageContainer onSuccess={(file) => setImages([...images, ...file])} />
                                    </div>
                                </div>


                                {/* Add Product */}
                                <div className='py-9 border-t'>
                                    <Button loading={isPending} onClick={addProduct} color="primary">Add Product</Button>
                                </div>

                            </div>
                        </div>
                    </Container>
                </div>
            )}




            {/* Variants */}

            {tab === 2 && (
                <div className="mt-7">
                    <Container>
                        <div className="w-full space-y-2">
                            {/* Colors */}
                            <div className="flex items-center gap-2 w-full">
                                <p className="text-sm w-20">Colors</p>
                                <div className="w-full">
                                    <Input placeholder='Red | Black' value={colors} onChange={(e) => setColors(e.target.value)} />
                                </div>
                            </div>
                            {/* Sizes */}
                            <div className="flex items-center gap-2 w-full">
                                <p className="text-sm w-20">Sizes</p>
                                <div className="w-full">
                                    <Input placeholder='S | M' value={sizes} onChange={(e) => setSizes(e.target.value)} />
                                </div>
                            </div>
                            {/* Material */}
                            <div className="flex items-center gap-2 w-full">
                                <p className="text-sm w-20">Materials</p>
                                <div className="w-full">
                                    <Input placeholder='Cork | Leather' value={material} onChange={(e) => setMaterial(e.target.value)} />
                                </div>
                            </div>
                            {/* Type */}
                            <div className="flex items-center gap-2 w-full">
                                <p className="text-sm w-20">Types</p>
                                <div className="w-full">
                                    <Input placeholder='Temperature | Non-Tempearture' value={type} onChange={(e) => setType(e.target.value)} />
                                </div>
                            </div>

                            {/* Generate  */}
                            <div className='pt-5'>
                                <Button onClick={generateVariants}>Generate Variants</Button>
                            </div>
                        </div>
                    </Container>




                    {/* Variants */}
                    <div className="mt-8">
                        {variants?.length > 1 &&
                            <Container>
                                <div className="space-y-2">
                                    {variants?.map((variant, i) => (
                                        <div className="flex items-center gap-2">
                                            <Avatar size='md' src={""} />
                                            <Input value={variant?.color} disabled />
                                            <Input value={variant?.size} disabled />
                                            <Input value={variant?.material} disabled />
                                            <Input value={variant?.type} disabled />
                                            <Input placeholder="Stock" value={variant?.stock} onChange={(e) => handleStock(i, e)} />
                                            <Input placeholder="Price" value={variant?.price} onChange={(e) => handlePrice(i, e)} />
                                        </div>
                                    ))}
                                </div>
                            </Container>
                        }
                    </div>
                </div>
            )}

        </div>
    )
}

export default CreateProduct